<template>
  <div>
    <!-- <div class="ssl-tabs">
      <button :class="{ active: activeTab === 'rsa' }" @click="activeTab = 'rsa'">RSA 证书</button>
      <button :class="{ active: activeTab === 'sm2' }" @click="activeTab = 'sm2'">SM2 证书</button>
    </div> -->

    <div class="ssl-section">
      <div v-for="section in certSections" :key="section.title" class="ssl-card">
        <img :src="section.image" alt="证书示意图" class="ssl-img" />
        <div class="product-info">
          <h3 class="product-name">{{ section.products[0].name }}</h3>
          <p class="product-desc">{{ section.products[0].desc }}</p>
          <ul class="product-features">
            <li v-for="(feat, i) in section.products[0].features" :key="i">
              <img src="../assets/icon.png" alt="" class="icon" /> {{ feat }}
            </li>
          </ul>
          <div class="product-price-row">
            <span class="price">￥{{ section.products[0].price }}</span>
            <span class="per-year"> / 年</span>
            <button @click="toPay(section.products[0])" class="buy-btn">立即购买</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {  } from "@/api/user.js";
export default {
  data() {
    return {
      activeTab: 'rsa',
      certSections: [
        {
          title: '超安SSL V1单域名证书',
          image: require('@/assets/icon1.png'),
          products: [
            {
              name: '超安SSL V1',
              price: 0.01,
              desc: '采用国密算法,从浏览器到服务器端之间自动实现高度加密通道,网站身份真实可信。',
              features: [
                '支持 SM2 国产密码算法',
                '绿色地址栏/安全锁',
                '地址栏显示单位名称',
                'V4 认证标识'
              ]
            }
          ]
        },
        {
          title: '超安SSL V2通配符证书',
          image: require('@/assets/icon2.png'), // 你要保存截图中的图为这个文件
          products: [
            {
              name: '超安SSL V3',
              price: 1850,
              desc: '采用国密算法,从浏览器到服务器端之间自动实现高强度加密通道加密信息,网站身份真实可信。',
              features: [
                '支持 SM2 国产密码算法',
                '地址栏显示单位名称',
                '安全锁/无警告',
                'V3 认证标识'
              ]
            }
          ]
        },
        {
          title: '超安SSL V3国际加密企业通配符',
          image: require('@/assets/icon3.png'),
          products: [
            {
              name: '超安SSL V1',
              price: 2650,
              desc: '采用国密算法,从浏览器到服务器端之间自动实现高强度加密通道,只验证域名所有权。',
              features: [
                '支持 SM2 国际密码算法',
                'V1 认证标识',
                '安全锁/无警告'
              ]
            }
          ]
        }
      ]
    };
  },
  methods: {
    toPay(info) {
      console.log(info)
      this.$router.push({
        name: 'information',
        params: { info }
      });
    }
  },
};
</script>

<style scoped>
.ssl-page {
  width: 100%;
  padding: 20px;
  background: #f9f9f9;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.ssl-tabs {
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
}
.ssl-tabs button {
  padding: 10px 20px;
  border: none;
  background: #e0e0e0;
  color: #333;
  font-size: 14px;
  margin: 0 8px;
  border-radius: 4px;
  cursor: pointer;
}
.ssl-tabs .active {
  background: #007bff;
  color: white;
}
.ssl-section {
  width: 100%;
  margin-bottom: 50px;
  border-radius: 8px;
}
.section-title {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 20px;
  color: #333;
  text-align: left;
}
.ssl-card {
  width: 80%;
  margin: 20px auto;
  display: flex;
  gap: 20px;
  background: #fff;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}
.ssl-img {
  width: 618px;
  height: 317px;
  border-radius: 6px;
  align-self: flex-start;
}
.product-info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
}
.product-name {
  font-size: 22px;
  font-weight: 600;
  color: #333;
  margin-bottom: 10px;
}
.product-desc {
  color: #666;
  margin-bottom: 12px;
  font-size: 14px;
}
.product-features {
  list-style: none;
  padding-left: 0;
  margin: 10px 0;
  color: #333;
}
.product-features li {
  margin-bottom: 6px;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
}
.icon {
  width: 16px;
  height: 16px;
}
.product-price-row {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-top: 10px;
  flex-wrap: wrap;
}
.price {
  color: #f60;
  font-weight: bold;
  font-size: 22px;
}
.per-year {
  font-size: 14px;
  color: #888;
}
.buy-btn {
  background: #2ecc71;
  color: #fff;
  padding: 10px 18px;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
}
</style>
